import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
// import { SocketsService } from '../../../services/sockets/sockets.service';

@Component({
  selector: 'app-error-404',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './error-404.component.html',
  styleUrl: './error-404.component.scss',
})
export class Error404Component {
  showButton = true;

  // constructor(private socketService: SocketsService) {}

  // ngOnInit(): void {
  //   this.socketService.onEvent('auth').subscribe(auth => {
  //     if (auth) {
  //       this.showButton = true;
  //     }
  //   });
  // }
}
